import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
import { bindSwiperNavigationA11y } from '../common/syncSwiperNavigationA11y';

export default class BannerLastNews {

    constructor() {
        this.sections = document.querySelectorAll('.block-banner-last-news');
        this.instances = [];
        this.handleResize = this.debounce(this.rebuild.bind(this), 300);

        this.ready();
        window.addEventListener('resize', this.handleResize);
    }

    debounce(fn, delay) {
        let timer;
        return (...args) => {
            clearTimeout(timer);
            timer = setTimeout(() => fn.apply(this, args), delay);
        };
    }

    rebuild() {
        this.instances.forEach(obj => {
            obj.main?.destroy(true, true);
        });
        this.instances = [];
        this.ready();
    }

    ready() {
        if (this.sections.length === 0) return;

        this.sections.forEach(section => {

            const slider = section.querySelector('.swiper');
            if (!slider) return;

            const navigationNext = section.querySelector('.slider-button-next');
            const navigationPrev = section.querySelector('.slider-button-prev');

            const swiperInstance = new Swiper(slider, {
                modules: [Navigation],
                spaceBetween: 24,
                grabCursor: true,
                watchSlidesProgress: true,
                slidesPerView: 1,
                navigation: navigationNext && navigationPrev ? {
                    nextEl: navigationNext,
                    prevEl: navigationPrev,
                } : false,
            });

            bindSwiperNavigationA11y(swiperInstance);

            this.instances.push({ main: swiperInstance });
        });
    }
}

if (document.querySelector('.block-banner-last-news')) {
    new BannerLastNews();
}